// extracted by mini-css-extract-plugin
export var button = "styles-module--button--2eb55";
export var contactContainer = "styles-module--contactContainer--de5e3";
export var container = "styles-module--container--3f585";
export var decor = "styles-module--decor--a0256";
export var expanded = "styles-module--expanded--fdea0";
export var expandedContent = "styles-module--expandedContent--d3833";
export var gomesLogo = "styles-module--gomesLogo--b542a";
export var hamburger = "styles-module--hamburger--9111b";
export var hamburgerBox = "styles-module--hamburger-box--d6cf0";
export var hamburgerInner = "styles-module--hamburger-inner--f2ac9";
export var hamburgerSqueeze = "styles-module--hamburger--squeeze--be98a";
export var headerContent = "styles-module--headerContent--d5c6e";
export var hidden = "styles-module--hidden--4bd2a";
export var iconContainer = "styles-module--iconContainer--76c96";
export var image = "styles-module--image--2ae3b";
export var imageContainer = "styles-module--imageContainer--233d6";
export var isActive = "styles-module--is-active--14498";
export var leftContainer = "styles-module--leftContainer--1e934";
export var lg = "styles-module--lg--848ff";
export var logoLink = "styles-module--logoLink--10465";
export var logoSmall = "styles-module--logoSmall--bd0bc";
export var logoTiny = "styles-module--logoTiny--8d7e3";
export var menuList = "styles-module--menuList--2f7fa";
export var mini = "styles-module--mini--3e688";
export var mobile = "styles-module--mobile--88361";
export var relativeWrapper = "styles-module--relativeWrapper--0aa11";
export var sm = "styles-module--sm--a872f";
export var zoomedIn = "styles-module--zoomedIn--48d3d";